import { resolveImage } from "@/lib/api";

export const Footer = ({ brand = "LUXOR", whatsappNumber, logo = "/logo.jpg", telegramLink = "", description = "" }) => {
  return (
    <footer className="border-t border-white/10 px-6 md:px-12 py-16" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <img src={resolveImage(logo)} alt={brand} className="h-24 w-24 object-cover object-center rounded-lg" />
            <p className="mt-6 max-w-md font-body text-sm text-zinc-500 leading-relaxed">
              {description || "Pharmaceutical-grade performance compounds. Discreet delivery, verified purity, WhatsApp ordering."}
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-body text-[10px] uppercase tracking-[0.3em] text-[#29FF87] mb-4">Catalogue</p>
            <ul className="space-y-3 font-body text-sm text-zinc-400">
              <li><a href="#injectable" className="hover:text-white transition-colors">Injectable</a></li>
              <li><a href="#oral" className="hover:text-white transition-colors">Oral</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-body text-[10px] uppercase tracking-[0.3em] text-[#29FF87] mb-4">Order</p>
            <div className="space-y-3">
              <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noreferrer" className="block font-body text-sm text-zinc-400 hover:text-white transition-colors" data-testid="footer-whatsapp">
                WhatsApp +{whatsappNumber}
              </a>
              {telegramLink && (
                <a href={telegramLink} target="_blank" rel="noreferrer" className="block font-body text-sm text-zinc-400 hover:text-white transition-colors" data-testid="footer-telegram">
                  Telegram
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 font-body text-xs text-zinc-600">
          <span>© {new Date().getFullYear()} {brand}. All rights reserved.</span>
          <span className="max-w-xl">For educational and research purposes. Consult local regulations before purchase.</span>
        </div>
      </div>
    </footer>
  );
};
